import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './pages/homepage/homepage'; 
import About from './pages/about/about';
import FocusArea from './pages/research/focusarea';
import People from './pages/research/People';
import FiveGLab from './pages/5glab/FiveGLab'
import IotDashboard from './pages/IoT/IotDashboard';
import Projects from './pages/research/projects';
import Publications from './pages/research/Publications';
import Contact from './pages/contact/Contact';
import AdminPage from './pages/admin/AdminPage';
import DigitalTwin from './pages/digitaltwin/DigitalTwin';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path='/about' element={<About />} />
          <Route path="/research/focus-area" element={<FocusArea />} />
          <Route path="/research/projects" element={<Projects />} />          
          <Route path="/research/people" element={<People />} />
          <Route path="/research/publications-patents" element={<Publications />} />
          <Route path="/5glab" element={<FiveGLab />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/iot-dashboard" element={<IotDashboard />} />
          <Route path="/digital-twin" element={<DigitalTwin />} />
          <Route path="/csrl-secure-admin-portal" element={<AdminPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
